@if (initialized) {
    <div class="grid mt-2">

        <div class="col-12">
            <div class="flex justify-content-between py-2 px-4 surface-0 align-items-center">
                <span style="font-size:16px; font-weight: 600;">Job-Überlappungen</span>
                <mvs-range-selector-overlay fieldName="e.start_time"
                                            (onChangeDate)="handleDateChange($event)"></mvs-range-selector-overlay>
            </div>
        </div>

        <!-- Left: Job Summary Overview -->
        <div [ngClass]="selectedWindow ? 'col-8' : 'col-12'">
            <p-table
                    [value]="jobWindows"
                    [(selection)]="selectedWindow"
                    selectionMode="single"
                    dataKey="id"
                    [scrollable]="true"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>Fenster Start</th>
                        <th>Fenster Ende</th>
                        <th>Überlapp. Start</th>
                        <th>Überlapp. Ende</th>
                        <th>Anzahl</th>
                        <th *ngIf="!selectedWindow">Gesamtdauer</th>
                        <th *ngIf="!selectedWindow">Durchschn. Dauer</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-window>
                    <tr [pSelectableRow]="window"
                        (click)="onWindowSelect(window)">
                        <td>{{ window.windowStart | date: 'dd.MM.yyyy HH:mm:ss.SSS' }}</td>
                        <td>{{ window.windowEnd | date: 'dd.MM.yyyy HH:mm:ss.SSS' }}</td>
                        <td>{{ window.overlapStart | date: 'dd.MM.yyyy HH:mm:ss.SSS' }}</td>
                        <td>{{ window.overlapEnd | date: 'dd.MM.yyyy HH:mm:ss.SSS' }}</td>
                        <td>{{ window.count }}</td>
                        <td *ngIf="!selectedWindow">{{ formatDuration(window.totalDurationSecs) }}</td>
                        <td *ngIf="!selectedWindow">{{ formatDuration(window.avgDurationSecs) }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <!-- Right: Selected Window Job Details -->
        <div [ngClass]="selectedWindow ? 'col-4' : 'col-12'">
            @if (selectedWindow) {
                <div class="card">
                    <div class="flex justify-content-between align-items-center flex-wrap mb-3">
                                    <span class="m-0 text-xl font-semibold">Jobs <span
                                            class="text-500 ml-2">(Count: {{ selectedWindow.count }})</span></span>

                        <div class="flex flex-column lg:flex-row gap-3 text-700">
                            <div class="flex align-items-center gap-2">
                                <i class="fa-regular fa-clock text-primary"></i>
                                <span><strong>Gesamt:</strong> {{ formatDuration(selectedWindow.totalDurationSecs) }}</span>
                            </div>
                            <div class="flex align-items-center gap-2">
                                <i class="fa-regular fa-stopwatch text-secondary"></i>
                                <span><strong>Durchschnitt:</strong> {{ formatDuration(selectedWindow.avgDurationSecs) }}</span>
                            </div>
                        </div>
                    </div>

                    <p-table
                            [value]="selectedWindow.jobs"
                            [(selection)]="selectedJob"
                            selectionMode="single"
                            [scrollable]="true"
                            scrollHeight="500px"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Instanz-ID</th>
                                <th>Job-Name</th>
                                <th>Status</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-job>
                            <tr [pSelectableRow]="job"
                                (click)="onJobSelect(job)">
                                <td>{{ job.id }}</td>
                                <td>{{ job.jobName }}</td>
                                <td>
                                    <p-tag
                                            [value]="job.statusInfo?.label"
                                            [icon]="job.statusInfo?.image"
                                            [style]="{
                                                color: 'var(--' + job.statusInfo?.color + ')',
                                                backgroundColor: 'var(--' + job.statusInfo?.backgroundColor + ')'
                                              }"
                                    ></p-tag>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                </div>
            }
        </div>
    </div>
    <!--Right Side Bar Job Instance Details-->
    <p-drawer
            [(visible)]="showJobInstanceSideBar"
            [style]="{width: '1000px'}"
            [modal]="false"
            position="right"
    >
        @if (selectedJob && showJobInstanceSideBar) {
            <jb-job-instance-details
                    [jobInstanceId]="selectedJob.id"
            ></jb-job-instance-details>
        }
    </p-drawer>
}